<template>
  <v-navigation-drawer class='text--light-5' id='app-drawer' v-model='inputValue' persistent app dark
    mobile-breakpoint="991" width="250">
    <v-layout class="fill-height_" tag="v-list" column>
      <v-list>
        <v-list-item style="margin:10px 10px 0px 10px;padding:10px;background-color:white;border-radius:0px !important;">
          <img style="width:100%" src='/img/Depalop_Logo.png' />
        </v-list-item>

        <div style="text-align:right;padding:0px;margin:0px 10px 0px 10px;background-color:white">
          <div style="color:black;padding:5px;padding-right:10px;font-weight: 400;">SERVICES</div>
        </div>

        <v-divider />
        <component v-for="(link, i) in allowedLinks" :is="link.type" :key="i" v-bind="link" avatar />
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex'
import links from './menu'

export default {
  data: () => ({
    logo: '/img/logo.png',
    responsive: true,
    links
  }),
  computed: {
    ...mapState('app', ['image', 'color', 'schema']),

    // display allowed links only
    allowedLinks() {
      return links.filter(link => !link.entity || this.$can(link.action, link.entity))
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      }
    },
    items() {
      return this.$t('Layout.View.items')
    },
    sidebarOverlayGradiant() {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
    }
  },
  async mounted() {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
#app-drawer {
  /*background-color: rgba(47, 47, 47, 0.84);*/
  color:black !important;

  .v-list-item {
    border-radius: 4px !important;

    &::before {
      border-radius: 4px !important;
    }
  }
}
</style>
